import React from "react";
import { FooterComponent } from "../../../shared_lib/bootstrap/footer/Footer";
import { useTranslation } from "react-i18next";

export const Footer: React.FC = () => {
  const { t }: any = useTranslation();
  const currentYear = new Date().getFullYear();
  return (
    <FooterComponent
      rightTemplate={<span>{`${t("layout.footer")}${currentYear}`}</span>}
    ></FooterComponent>
  );
};
